<script setup>

import { ButtonSize, ButtonType } from '@/components/Forms/Buttons/SubmitButtonConstants.js'
import { useClipboard } from '@vueuse/core'
import { Toaster } from '@/models/utils/Toaster.js'
import BaseModal from '@/components/Alerts/BaseModal.vue'
import SubmitButton from '@/components/Forms/Buttons/SubmitButton.vue'

const toaster = new Toaster();

const props = defineProps({
	show: { type: Boolean, default: false },
	title: { type: String, default: '' },
	message: { type: String, default: '' },
	formattedMessage: { type: String, default: '' },
	subMessage: { type: String, default: '' },
})

const emit = defineEmits(['close']);

function copyText()
{
	useClipboard({ legacy: true }).copy(props.message)

	toaster.success("Copied!")
}
</script>

<template>
	<BaseModal :show="show">
		<form class="flex flex-col max-h-[calc(100vh_-_8.125rem)] max-w-[calc(100vw_-_8.125rem)]">
			<div class="flex items-center space-x-2">
				<p class="text-xl font-bold text-heading">{{ props.title }}</p>
			</div>

			<p class="leading-6 text-grayscale-body mt-3 overflow-auto whitespace-pre-wrap" v-html="props.formattedMessage"/>
			<p v-if="subMessage !== ''" class="leading-6 text-label mt-2 text-sm font-bold" v-html="props.subMessage"/>

			<div class="flex flex-row mt-5 ml-auto space-x-4">
				<SubmitButton label="Copy Text" :type="ButtonType.Outline" :size="ButtonSize.Small" @click.prevent="copyText()" />
				<SubmitButton label="Ok" :type="ButtonType.Default" :size="ButtonSize.Small" @click.prevent="emit('close')" />
			</div>
		</form>
	</BaseModal>
</template>

<style scoped>

</style>